import { IScaleMovementQuery, IScaleQuery } from "../../models/scale/query";
import {
  IScale,
  IScaleDetails,
  IScaleMovement,
  IScalePendingChanges,
  IScalePendingChangesSummary,
  IScaleSlot,
} from "../../models/scale/response";
import IBaseListingResponse from "../../utils/api/base-listing-response";
import toggleLoading from "../../utils/helpers/xor";
import paramsReducer from "../base/base-reducer";
import { QueryAction } from "../base/base-reducer";
import { IInternalState, ScaleLoading } from "./context";

type Action =
  | {
      type: "LOADING";
      payload: { loading: ScaleLoading | ScaleLoading[] };
    }
  | {
      type: "SET_LIST";
      payload: { list: IBaseListingResponse<IScale> };
    }
  | {
      type: "SET_DETAILSS";
      payload: { details?: IScaleDetails };
    }
  | {
      type: "SET_SLOTS";
      payload: { slots: IScaleSlot[] };
    }
  | {
      type: "SET_PENDING_CHANGES";
      payload: { pendingChanges?: IScalePendingChanges };
    }
  | {
      type: "SET_PENDING_SUMMARIES";
      payload: { summaries: IScalePendingChangesSummary[] };
    }
  | {
      type: "SET_MOVEMENTS";
      payload: { movements: IBaseListingResponse<IScaleMovement> };
    }
  | {
      type: "SET_MOVEMENTS_QUERY";
      payload: { query: IScaleMovementQuery };
    }
  | QueryAction<IScaleQuery>;

const reducer = (state: IInternalState, action: Action): IInternalState => {
  switch (action.type) {
    case "LOADING": {
      return {
        ...state,
        loading: toggleLoading(state.loading, action.payload.loading),
      };
    }
    case "SET_LIST": {
      return {
        ...state,
        list: action.payload.list,
      };
    }

    case "SET_DETAILSS": {
      return {
        ...state,
        details: action.payload.details,
      };
    }

    case "SET_SLOTS": {
      return {
        ...state,
        slots: action.payload.slots,
      };
    }

    case "SET_PENDING_CHANGES": {
      return {
        ...state,
        pendingChanges: action.payload.pendingChanges,
      };
    }

    case "SET_PENDING_SUMMARIES": {
      return {
        ...state,
        pendingSummaries: (Array.isArray(action.payload.summaries)
          ? action.payload.summaries
          : []
        ).reduce(
          (result, summary) => ({ ...result, [summary.scaleId]: summary }),
          {} as Record<number, IScalePendingChangesSummary>,
        ),
      };
    }

    case "SET_MOVEMENTS": {
      return {
        ...state,
        movements: action.payload.movements,
      };
    }

    case "SET_MOVEMENTS_QUERY": {
      return {
        ...state,
        movementsQuery: action.payload.query,
      };
    }

    default: {
      return paramsReducer(state, action);
    }
  }
};

export default reducer;
